import { useEffect, useMemo } from "react"

import { Spin } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import EmptyComponent from "../../../Components/Empty"
import { RoutesPaths } from "../../../constants/user-routes"
import { useOpenDeflectPage, useProgramCount } from "../hooks/useDeflectFilters"
import { DEFLECT_SECTION } from "../redux/deflectAnalytics.constants"
import {
  selectDeflectFetching,
  selectDeflectFirstLoad,
  selectDeflectSection
} from "../redux/deflectAnalytics.slice"
import { toMatchRateGrid } from "../utils/matchRateGrid"
import MatchRateGrid from "./MatchRateGrid/MatchRateGrid"
import MatchRateGridSkeleton from "./MatchRateGrid/MatchRateGridSkeleton"
import Section from "./Section"

// "Match rate: channel × program" heat map card. The grid is shared with the full inner page,
// which adds the exact figures behind each row.
const MatchRateMatrix = ({ getData }) => {
  const { t } = useTranslation()
  const openPage = useOpenDeflectPage()
  const matrix = useSelector(selectDeflectSection(DEFLECT_SECTION.MATCH_RATE_MATRIX))
  const fetching = useSelector(selectDeflectFetching(DEFLECT_SECTION.MATCH_RATE_MATRIX))
  const firstLoad = useSelector(selectDeflectFirstLoad(DEFLECT_SECTION.MATCH_RATE_MATRIX))
  const programCount = useProgramCount()

  useEffect(() => {
    getData(DEFLECT_SECTION.MATCH_RATE_MATRIX)
  }, [getData])

  const { cols, rows } = useMemo(() => toMatchRateGrid(matrix), [matrix])
  const hasData = rows.some((row) => row.cells.some((cell) => cell.rate != null))

  return (
    <Section
      title={t("Match rate: channel × program")}
      tooltip={t(
        "Match rate for each channel and program, over the lookups served while that program was Active. Mastercom exists on Consumer Clarity only."
      )}
      onViewAll={hasData ? () => openPage(RoutesPaths.deflect.analytics_match_rate) : undefined}
    >
      {firstLoad ? (
        <MatchRateGridSkeleton programCount={programCount} />
      ) : (
        <Spin spinning={fetching}>
          {hasData ? (
            <MatchRateGrid cols={cols} rows={rows} />
          ) : (
            <EmptyComponent type="no_data_available" />
          )}
        </Spin>
      )}
    </Section>
  )
}

export default MatchRateMatrix
